const getDocumentDisplayLabel = (document) => {
  let effectiveDateDisplay = "n/a";
  if (document.effectiveDate)
  {
    var parts = document.effectiveDate.split("-");
    const startDateObj = new Date(parts[0], parts[1] - 1, parts[2]);
    effectiveDateDisplay = new Date(startDateObj).toLocaleDateString("en-US");
  }

  let expirationDateDisplay = "n/a";
  if (document.expiration)
  {
    var parts = document.expiration.split("-");
    const endDateObj = new Date(parts[0], parts[1] - 1, parts[2]);
    expirationDateDisplay = new Date(endDateObj).toLocaleDateString("en-US");
  }

  return document.filename + " (" + (effectiveDateDisplay ? effectiveDateDisplay : "n/a") + " - " + (expirationDateDisplay ? expirationDateDisplay : "n/a") + ")";
}

export { getDocumentDisplayLabel };